export default "__VITE_ASSET__CB6F0PHG__"